import {
  CheckBadgeIcon,
  CheckCircleIcon,
  RectangleGroupIcon,
  QueueListIcon,
  UserIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline"

import { StatCardCompact } from "@components"
import PropTypes from "prop-types"

const Stats = ({ summary = {} }) => {
  const {
    bookable = 0,
    has_booked = 0,
    has_not_booked = 0,
    no_of_groups = 0,
    no_of_guardians = 0,
    total = 0,
  } = summary?.data?.reportWaitingListSummary || {}

  return (
    <div className="grid grid-cols-1 gap-5 my-5 auto-rows-fr sm:grid-cols-3 2xl:grid-cols-6">
      <StatCardCompact
        title="Total"
        stat={total}
        icon={<QueueListIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Not Booked"
        stat={has_not_booked}
        icon={<XCircleIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Has Booked"
        stat={has_booked}
        icon={<CheckCircleIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Bookable"
        stat={bookable}
        icon={<CheckBadgeIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Groups"
        stat={no_of_groups}
        icon={<RectangleGroupIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Guardians"
        stat={no_of_guardians}
        icon={<UserIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />
    </div>
  )
}

Stats.propTypes = {
  summary: PropTypes.object,
}

export default Stats
